import apiBaseUrl from '../../utils/config.js';

class InsurancePatientInfoService {
  constructor() {
    this.baseUrl = `${apiBaseUrl}/insurancePatientInfo`;
  }

  getToken() {
    return localStorage.getItem("jwt");
  }

  getAuthHeaders() {
    const token = this.getToken();
    return {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
    };
  }

  async #request(endpoint, method = 'GET', body = null) {
    const options = {
      method,
      headers: this.getAuthHeaders(),
    };

    if (body) {
      options.body = JSON.stringify(body);
    }

    try {
      const response = await fetch(`${this.baseUrl}${endpoint}`, options);
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Request failed: ${errorText}`);
      }
      return response.headers.get('Content-Type')?.includes('application/json')
        ? await response.json()
        : await response.text();
    } catch (error) {
      console.error(`Error during ${method} ${endpoint}:`, error);
      throw error;
    }
  }

  async saveOrUpdate(record) {
    return this.#request('/save', 'POST', record);
  }

  async getAllRecords() {
    return this.#request('/all');
  }

  async getById(id) {
    return this.#request(`/${id}`);
  }

  async getByPatientId(patientId) {
    return this.#request(`/patient/${patientId}`);
  }

  async deleteById(id) {
    return this.#request(`/delete/${id}`, 'DELETE');
  }

  async updateFields(id, updates) {
    return this.#request(`/update/${id}`, 'PATCH', updates);
  }

  async getActiveAsList(id) {
    return this.#request(`/${id}/active`);
  }

  async addActiveValue(id, value) {
    return this.#request(`/${id}/active/add`, 'POST', { value });
  }

  async editActiveValue(id, oldValue, newValue) {
    return this.#request(`/${id}/active/edit`, 'PUT', { oldValue, newValue });
  }
}

export default InsurancePatientInfoService;
